import React from 'react';

const TableRow = ({ rowNum, children }) => {
    return <tr className={rowNum % 2 === 0 ? 'bg-gray-50' : 'bg-transparent'}>{children}</tr>;
};

export default TableRow;
